import { useQuery } from '@hooks/reactQuery';

import { ITableDatepickerFilter, TTableFilter } from '@interfaces/components/table';
import { IAssetRequestType, IAssetsRequestsDTO } from '@interfaces/rent/dto/assetRentDTO';

interface IUseQueryAssetRentRequestParams extends IAssetsRequestsDTO {
	getRequestFunction: (params: IAssetsRequestsDTO) => Promise<any>;
	filters: Array<TTableFilter>;
	dateFilters?: Array<ITableDatepickerFilter>;
	queryKey: string;
	isAO: boolean;
}

interface IUseQueryAssetRentRequestReturnType {
	countOfRecords: number;
	isLoading: boolean;
	requests: Array<IAssetRequestType>;
}

export const useQueryAssetRentRequest = (
	params: IUseQueryAssetRentRequestParams,
): IUseQueryAssetRentRequestReturnType => {
	const {
		assetOwnerId,
		dateFilters = [],
		filters = [],
		getRequestFunction,
		networkOperatorId,
		page,
		pageSize,
		queryKey,
		requestStatus,
		requestType,
		requestedEndDate,
		requestedStartDate,
		searchValue,
		sortBy,
	} = params;

	const filterParams = filters.reduce((acc: any, item: any) => {
		if (item?.option?.value) {
			acc[item.name] = item.option.value;
		}

		return acc;
	}, {});

	const dateFilterParams = dateFilters.reduce((acc: any, item: any) => {
		if (item.selected) {
			acc[item.name] = item.selected;
		}

		return acc;
	}, {});

	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [
			assetOwnerId,
			dateFilterParams,
			filterParams,
			networkOperatorId,
			page,
			pageSize,
			queryKey,
			requestStatus,
			requestType,
			requestedEndDate,
			requestedStartDate,
			searchValue,
			sortBy,
		],
		queryFn: () => getRequestFunction({
			assetOwnerId,
			dateFilterParams,
			filterParams,
			networkOperatorId,
			page,
			pageSize,
			requestStatus,
			requestType,
			requestedEndDate,
			requestedStartDate,
			searchValue,
			sortBy,
		}),
		refetchOnWindowFocus: false,
	});

	return {
		requests: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoading: isInitialLoading,
	};
};
